// extracted by mini-css-extract-plugin
export default {"imageWrapper":"DG-z","hovered":"EG-z","hoverImage":"FG-z","mainImage":"GG-z","imageNoBackground":"HG-z","fullSizeImage":"IG-z"};